<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-text1 animate-target" v-animate-in>Watch clinical commentary from Roberto Pecoits-Filho, MD, PhD, FASN, FACP.</div>
    <div class="ctn-text2 animate-target" v-animate-in>Dr Roberto Pecoits-Filho is a Nephrologist and Research Scientist at Arbor Research, Michigan and Pontifical Catholic University of Paraná</div>
    <iframe class="p-video animate-target" v-animate-in
      src="https://player.vimeo.com/video/1219787787?h=13a072d309&title=0&byline=0&portrait=0&autoplay=1"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen>
    </iframe>
    <GoNext class="animate-target" v-animate-in href="/section4/4-3">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s4-2",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"<sup>*</sup>ACEi or ARB (at maximal tolerated doses) should be first line therapy for hypertension when albuminuria is present. Otherwise, dihydropyridine calcium channel blocker or diuretic can also be considered; all three classes are often needed to attain BP targets; #glycaemia, albuminuria, BP, CV disease risk and lipids; †finerenone is currently the only nonsteroidal MRA with proven clinical kidney and CV benefits; §after treatment with RASis in patients with UACR ≥30 mg/g and normal serum potassium.<br/><div class='brs'></div>"
      +"ACR, albumin to creatinine ratio; ASCVD, atherosclerotic cardiovascular disease; CCB, calcium channel blocker; CVD, cardiovascular disease; GLP-1 RA, glucagon like peptide-1 receptor agonist; HTN, hypertension; PCSK9i, proprotein convertase subtilisin/kexin type 9 inhibitor; RAS, renin angiotensin system; T1D, type 1 diabetes<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Kidney Disease: Improving Global Outcomes (KDIGO). <i>Kidney Int</i> 2022;102:S1–S128.<br/>"
      +"2. de Boer IH, <i>et al. Diabetes Care</i> 2022;45:3075–3090",
      title:"International and local guidelines are now in consensus about the role of nonsteroidal MRAs (finerenone) for people with T2D and CKD<sup>1,2</sup>"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section4/s4.css";
.ctn-text1 {
  font-size: 20px;
  color: #000;
  font-weight: bold;
  margin-top: 40px;
}
.ctn-text2 {
  font-size: 20px;
  color: #000;
  margin-top: 30px;
}
.p-video {
  margin-top: 30px;
  width:100%;
  aspect-ratio: 16/9;
}
</style>
